import { render, staticRenderFns } from "./legal-order.vue?vue&type=template&id=3011e18a&scoped=true&"
import script from "./legal-order.vue?vue&type=script&lang=js&"
export * from "./legal-order.vue?vue&type=script&lang=js&"
import style0 from "./legal-order.vue?vue&type=style&index=0&id=3011e18a&prod&lang=less&"
import style1 from "./legal-order.vue?vue&type=style&index=1&id=3011e18a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011e18a",
  null
  
)

export default component.exports